// src/redux/slices/layoutSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LayoutState {
  pageLoading: boolean | false;
  logo: string | null;
  footerText: string;
  editor: string;
  recaptcha: boolean;
  siteStatus: boolean;
}

const initialState: LayoutState = {
  logo: null,
  footerText: '',
  pageLoading: false,
  editor: 'quill',
  recaptcha:false,
  siteStatus:true,
};

const layoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    setLogo(state, action: PayloadAction<string>) {
      state.logo = action.payload;
    },
    setFooterText(state, action: PayloadAction<string>) {
      state.footerText = action.payload;
    },
    setPageLoading(state, action: PayloadAction<boolean>) {
      state.pageLoading = action.payload;
    },
    setEditor(state, action: PayloadAction<string>) {
      state.editor = action.payload;
    },
    setRecaptcha(state, action: PayloadAction<boolean>) {
      state.recaptcha = action.payload;
    },
    setSiteStatus(state, action: PayloadAction<boolean>) {
      state.siteStatus = action.payload;
    },
  },
});

export const { setLogo, setFooterText, setPageLoading,setEditor,setRecaptcha,setSiteStatus } = layoutSlice.actions;
export default layoutSlice.reducer;
